// leaves-routing.module.ts
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DashboardComponent } from '../../dev-support/dashboard/dashboard.component';
import { PdfExampleComponent } from '../../testing-pages/pdf-example/pdf-example.component';
import { CategoryDataJobComponent } from '../../invoice/invoice-jobs/category-data-job/category-data-job.component';
import { LineItemJobComponent } from '../../invoice/invoice-jobs/line-item-job/line-item-job.component';
import { StatementLineItemJobComponent } from '../../invoice/invoice-jobs/statement-line-item-job/statement-line-item-job.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';
import { DocumentStatusComponent } from '../../invoice/document-status/document-status.component';
import { DiscardJobComponent } from '../../invoice/invoice-jobs/discard-job/discard-job.component';
import { DuplicateJobComponent } from '../../invoice/invoice-jobs/duplicate-job/duplicate-job.component';
import { RescanJobComponent } from '../../invoice/invoice-jobs/rescan-job/rescan-job.component';
import { GlobalAbnConfigComponent } from '../../invoice/configurations/global-abn-config/global-abn-config.component';
import { GlobalSupplierConfigComponent } from '../../invoice/configurations/global-supplier-config/global-supplier-config.component';
import { GlobalSupplierAbnConfigComponent } from '../../invoice/configurations/global-supplier-abn-config/global-supplier-abn-config.component';
import { GlobalSupplierStoreMapConfigComponent } from '../../invoice/configurations/global-supplier-store-map-config/global-supplier-store-map-config.component';
import { GlobalSupplierStoreTypeConfigComponent } from '../../invoice/configurations/global-supplier-store-type-config/global-supplier-store-type-config.component';
import { GlobalSupplierTypeConfigComponent } from '../../invoice/configurations/global-supplier-type-config/global-supplier-type-config.component';
import { GlobalSupplierTypeFieldConfigComponent } from '../../invoice/configurations/global-supplier-type-field-config/global-supplier-type-field-config.component';
import { ConfigurationDeactivateGuard } from 'src/app/handlers/ConfigurationGuard.guard';
import { OcrFlowDashboardComponent } from '../../invoice/ocr-flow-dashboard/ocr-flow-dashboard.component';
import { SourceConfigComponent } from '../../invoice/configurations/source-config/source-config.component';
import { OcrJob } from 'src/app/constants/constants';
import { StoreConfigComponent } from '../../invoice/configurations/store-config/store-config.component';
import { StorePriorityComponent } from '../../invoice/store-priority/store-priority.component';
import { DocumentViewerComponent } from '../../invoice/support/document-viewer/document-viewer.component';
import { ClientConfigurationComponent } from '../../invoice/support/client-configuration/client-configuration.component';
import { GlobalProductConfigComponent } from '../../invoice/configurations/global-product-config/global-product-config.component';
import { GlobalNonStandardProductConfigComponent } from '../../invoice/configurations/global-non-standard-product-config/global-non-standard-product-config.component';
import { DefaultStoreTypeSettingsConfigComponent } from '../../invoice/configurations/default-store-type-settings-config/default-store-type-settings-config.component';
import { InvoiceRuleConfigComponent } from '../../invoice/configurations/invoice-rule-config/invoice-rule-config.component';
import { InvoiceRuleMapConfigComponent } from '../../invoice/configurations/invoice-rule-map-config/invoice-rule-map-config.component';
import { MissingConfigurationJobComponent } from '../../invoice/invoice-jobs/missing-configuration-job/missing-configuration-job.component';
import { DocumentActionsComponent } from '../../invoice/support/document-actions/document-actions.component';
import { DocumentListComponent } from '../../document/document-list.component';
import { DocumentDetailComponent } from '../../document/document-detail/document-detail.component';
import { MasterProductListComponent } from '../../master-product/master-product-list.component';
import { GlobalStorePurchasePluConfigComponent } from '../../invoice/configurations/global-store-purchase-plu-config/global-store-purchase-plu-config.component';
import { PoolGroupConfigComponent } from '../../invoice/configurations/pool-group-config/pool-group-config.component';
import { UserPoolGroupConfigComponent } from '../../invoice/configurations/user-pool-group-config/user-pool-group-config.component';
import { StoreEmailConfigComponent } from '../../invoice/configurations/store-email-config/store-email-config.component';
import { HistoricalLineItemConfigComponent } from '../../invoice/configurations/historical-line_item-config/historical-line-item-config.component';
import { GlobalDepartmentConfigComponent } from '../../invoice/configurations/global-department-config/global-department-config.component';
import { GlobalSupplierStoreDepartmentConfigComponent } from '../../invoice/configurations/global-supplier-store-department-config/global-supplier-store-department-config.component';
import { GlobalSupplierStoreDepartmentPurchasePluConfigComponent } from '../../invoice/configurations/global-supplier-store-department-purchase-plu-config/global-supplier-store-department-purchase-plu-config.component';

const route: Routes = [
  {
    path: '', children: [
      { path: 'Dashboard', component: DashboardComponent, canActivate: [AuthGuard] },

      { path: 'ClientConfiguration', component: ClientConfigurationComponent, canActivate: [AuthGuard] },

      { path: 'DocumentStatus', component: DocumentStatusComponent, canActivate: [AuthGuard] },
      { path: 'CategoryDataJob', component: CategoryDataJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'LineItemJob', component: LineItemJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'StatementLineItemJob', component: StatementLineItemJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'DiscardJob', component: DiscardJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'DuplicateJob', component: DuplicateJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'RescanJob', component: RescanJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'MissingConfigurationJob', component: MissingConfigurationJobComponent, canActivate: [AuthGuard], canDeactivate: [ConfigurationDeactivateGuard] },
      { path: 'OcrFlowDashboard', component: OcrFlowDashboardComponent, canActivate: [AuthGuard] },

      { path: 'GlobalAbnConfig', component: GlobalAbnConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierConfig', component: GlobalSupplierConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierAbnConfig', component: GlobalSupplierAbnConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierStoreMapConfig', component: GlobalSupplierStoreMapConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierStoreTypeConfig', component: GlobalSupplierStoreTypeConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierTypeConfig', component: GlobalSupplierTypeConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierTypeFieldConfig', component: GlobalSupplierTypeFieldConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalDepartmentConfig', component: GlobalDepartmentConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierStoreDepartmentConfig', component: GlobalSupplierStoreDepartmentConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalSupplierStoreDepartmentPurchasePluConfig', component: GlobalSupplierStoreDepartmentPurchasePluConfigComponent, canActivate: [AuthGuard] },
      { path: 'StoreConfiguration', component: StoreConfigComponent, canActivate: [AuthGuard] },
      { path: 'SourceConfig', component: SourceConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalProductConfig', component: GlobalProductConfigComponent, canActivate: [AuthGuard] },
      { path: 'InvoiceRuleConfig', component: InvoiceRuleConfigComponent, canActivate: [AuthGuard] },
      { path: 'InvoiceRuleMapConfig', component: InvoiceRuleMapConfigComponent, canActivate: [AuthGuard] },
      { path: 'PoolGroupConfig', component: PoolGroupConfigComponent, canActivate: [AuthGuard] },
      { path: 'UserPoolGroupConfig', component: UserPoolGroupConfigComponent, canActivate: [AuthGuard] },
      { path: 'HistoricalLineItemConfig', component: HistoricalLineItemConfigComponent, canActivate: [AuthGuard] },
      { path: 'StoreEmailConfig', component: StoreEmailConfigComponent, canActivate: [AuthGuard] },

      { path: 'GlobalNonStandardProductConfig', component: GlobalNonStandardProductConfigComponent, canActivate: [AuthGuard] },
      { path: 'GlobalStorePurchasePluConfig', component: GlobalStorePurchasePluConfigComponent, canActivate: [AuthGuard] },
      { path: 'DefaultStoreTypeSettingsConfig', component: DefaultStoreTypeSettingsConfigComponent, canActivate: [AuthGuard] },

      { path: 'StorePriority', component: StorePriorityComponent, canActivate: [AuthGuard] },

      { path: 'PDFExample', component: PdfExampleComponent, canActivate: [AuthGuard] },

      { path: 'DocumentViewer', component: DocumentViewerComponent, canActivate: [AuthGuard] },
      { path: 'ClientConfiguration', component: ClientConfigurationComponent, canActivate: [AuthGuard] },
      { path: 'DocumentActions', component: DocumentActionsComponent, canActivate: [AuthGuard] },

      { path: 'MasterProduct', component: MasterProductListComponent, canActivate: [AuthGuard] },
      { path: 'Document', component: DocumentListComponent, canActivate: [AuthGuard] },
      { path: 'Document/:id/:fileUuid', component: DocumentDetailComponent, canActivate: [AuthGuard] },

      { path: '**', pathMatch: 'full', redirectTo: 'Dashboard' }

    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(route)],
  exports: [RouterModule]
})

export class NavRoutingModule { }

export namespace NavRoutingLinkModule {
  export const links: RouteCategory[] = [
    {
      name: 'Dev Support',
      link: [
        { name: 'Dashboard', icon: 'dashboard', path: 'Dashboard' }
      ]
    },
    {
      name: 'Invoice',
      countConfig: { api: ABCisApi.Support, url: 'monitor/web-ui-job-counts' },
      link: [
        { name: 'Document Status', icon: 'notes', path: 'DocumentStatus' },
        { name: 'OCR Flow', icon: ' linear_scale', path: 'OcrFlowDashboard' },
        { name: 'Store Priority', icon: ' home', path: 'StorePriority' },
        {
          name: 'Invoice Jobs', icon: 'note_add', links: [
            { name: 'Category Job', icon: 'description', path: 'CategoryDataJob', count: { jobId: OcrJob.EXTRACT_CATEGORY_DATA } },
            { name: 'H&L Job', icon: 'list_alt', path: 'LineItemJob', count: { jobId: OcrJob.EXTRACT_HEADER_AND_LINE_ITEM_DATA } },
            { name: 'H&L Job Statements', icon: 'list_alt', path: 'StatementLineItemJob', count: { jobId: OcrJob.EXTRACT_STATEMENT_HEADER_AND_LINE_ITEM_DATA } },
            { name: 'Discard Job', icon: 'delete_forever', path: 'DiscardJob', count: { jobId: OcrJob.OCR_DISCARD } },
            { name: 'Duplicate Job', icon: 'filter_none', path: 'DuplicateJob', count: { jobId: OcrJob.DUPLICATE_TO_BE_CONFIRMED } },
            { name: 'Rescan Job', icon: 'scanner', path: 'RescanJob', count: { jobId: OcrJob.REQUEST_RESCAN } },
          ]
        },
        {
          name: 'Configurations', icon: 'settings', links: [
            { name: 'Global Abn', path: 'GlobalAbnConfig' },
            { name: 'Global Supplier', path: 'GlobalSupplierConfig' },
            { name: 'Global Supplier Abn', path: 'GlobalSupplierAbnConfig' },
            { name: 'Global Supplier Store Map', path: 'GlobalSupplierStoreMapConfig' },
            { name: 'Global Supplier Store Type', path: 'GlobalSupplierStoreTypeConfig' },
            { name: 'Global Supplier Type', path: 'GlobalSupplierTypeConfig' },
            { name: 'Global Supplier Type Field', path: 'GlobalSupplierTypeFieldConfig' },
            { name: 'Global Department', path: 'GlobalDepartmentConfig' },
            { name: 'Global Supplier Store Department', path: 'GlobalSupplierStoreDepartmentConfig' },
            { name: 'Global Supplier Store Department Purchase PLU', path: 'GlobalSupplierStoreDepartmentPurchasePluConfig' },
            { name: 'Source Config', path: 'SourceConfig' },
            { name: 'Store Configuration', path: 'StoreConfiguration' },
            { name: 'Global Product', path: 'GlobalProductConfig' },
            { name: 'Global Non Standard Product', path: 'GlobalNonStandardProductConfig' },
            { name: 'Global Store Purchase PLU', path: 'GlobalStorePurchasePluConfig' },
            { name: 'Default Store Type Settings', path: 'DefaultStoreTypeSettingsConfig' },
            { name: 'Invoice Rule Config', path: 'InvoiceRuleConfig' },
            { name: 'Invoice Rule Map Config', path: 'InvoiceRuleMapConfig' },
            { name: 'Pool Group Config', path: 'PoolGroupConfig' },
            { name: 'User Pool Group Config', path: 'UserPoolGroupConfig' },
            { name: 'Historical Line Item', path: 'HistoricalLineItemConfig' },
            { name: 'Store Email Config', path: 'StoreEmailConfig' }
          ]
        },
        {
          name: 'Support', icon: 'person', links: [
            { name: 'Document Viewer', icon: 'note', path: 'DocumentViewer' },
            { name: 'Client Configuration', icon: 'face', path: 'ClientConfiguration' },
            { name: 'OCR Actions', icon: 'build', path: 'DocumentActions' }
          ]
        },
      ]
    },
    {
      name: 'Document List',
      link: [
        { name: 'Master Product', icon: 'category', path: 'MasterProduct' },
        // { name: 'Document Mapping', icon: 'source', path: 'Document' },
      ]
    },
  ];
}

export class RouteCategory {
  name: string;
  countConfig?: CountApiConfig;
  link: RouteLink[];
}

export class RouteLink {
  name: string;
  icon?: string;
  links?: RouteLink[];
  path?: string;
  count?: CountConfig;
}

export class CountApiConfig {
  api: ABCisApi;
  url: string;
}

export class CountConfig {
  jobId: number;
  pendingCount?: number;
}





